import React from "react";
import PropTypes from "prop-types";

const TimePicker = ({ handleChange, value }) => {
  const time = Array(24).fill(0);

  return (
    <select
      className="ui-timepicker-select"
      value={value}
      onChange={e => handleChange(e.target.value)}
    >
      {time.map((_, index) => {
        let hour = index.toString();
        if (index < 10) {
          hour = "0" + hour.toString();
        }
        return (
          <React.Fragment key={index}>
            <option value={`${hour}:00`}>{`${hour}:00`}</option>
            <option value={`${hour}:30`}>{`${hour}:30`}</option>
          </React.Fragment>
        );
      })}
    </select>
  );
};

TimePicker.propTypes = {
  handleChange: PropTypes.func
};

export default TimePicker;
